/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
/**
 * 操作
 */
export enum UnixConfigCardActionTypeE {
    // 创建
    CREATE = 'create',
    // 修改
    MODIFY = 'modify',
    // 详情
    DETAIL = 'detail',
}

/**
 * 入口
 */
export enum UnixConfigCardEntryTypeE {
    // 文件系统
    FILESYSTEM = 'filesystem',
    // dtree
    DTREE = 'dtree',
}

/**
 * 根目录权限枚举
 */
export enum UnixPermissionE {
    // 执行
    EXECUTE = 0,
    // 写入
    WRITE = 1,
    // 读取
    READ = 2,
}
